export function farloUiSliderReviews(element) {
  if (!element) return;

  let flkty;

  element.classList.remove('flickity-enabled', 'is-draggable');

  imagesLoaded(element, () => init());

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (flkty) flkty.resize();
    }, 150);
  });

  function init() {
    if (flkty) flkty.destroy();
    flkty = new Flickity(element, {
      cellAlign: 'center',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      wrapAround: true,
      groupCells: false,
      freeScroll: false,
      draggable: true,
      adaptiveHeight: false,
      autoPlay: true,
    });

    flkty.on('ready', () => flkty.resize());
    setTimeout(() => flkty.resize(), 100);
  }
}
